// extracted by mini-css-extract-plugin
module.exports = {"advantage":"PCtvx5gZ","title":"PhmDVzI_","section":"k4OdhSHY","row":"__8tP5hD6A"};